import api from '../api'
import {VersionedAPIPath} from "@/api/api";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";
import store from "@/store";
//DON NOT FORGET TO CHANGE IN SERVICE WORKERS AFTER CHANGING PATH (VERSION IS OK)
const routePrefix = VersionedAPIPath+'/submit-lmra-data';

export default {
    async reportIncident($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/incident-report'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    async reportNearIncident($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/near-incident'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    async reportRiskAnalysis($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/risk-analysis'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    async reportProcessIssue($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/process-issue'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    async sendBasicLmra($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/basic-lmra'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    async sendCustomLmra($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/custom-lmra'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    async sendWorkReport($data){
        sendingLmraDataHelper.showSendingDataLoader(true);
        let $url = routePrefix+'/work-report'
        return api.post($url,$data, this.getAdditionalHeaders());
    },
    getAdditionalHeaders(){
        return {
            headers : {
                'User-Language' : store.getters.getUserLanguage
            }
        }
    }
}